// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__aiM0c","ant-page-header-heading-title":"styles_ant-page-header-heading-title__q6H61","table":"styles_table__dJXWc"};